<template>
  <el-dialog
    v-if="visible"
    title="WEB応募ページのプレビュー"
    :visible.sync="visible"
    :before-close="close"
    custom-class="with-title"
  >
    <div class="preview-wrap">
      <div v-for="(item, index) in preview" :key="index">
        <a :href="item.url" target="_blank" @click="clickTrackingEvent(item.value)">
          <i class="mdi mdi-open-in-new"></i>
          {{ item.title }}
        </a>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="close">キャンセル</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.preview-wrap {
  display: flex;
  flex-flow: column;
  gap: $spacing-unit * 4;
  margin-top: $spacing-unit * 2;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

import Message from '@/client/components/_atoms/Message.vue'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    Message
  },
  data() {
    return {
      visible: false,
      preview: [] as { title: string; url: string; value: string }[]
    }
  },
  methods: {
    /**
     * ダイアログキャンペーンを開く
     */
    async open(preview: { beginUrl: string; endUrl: string; currentUrl: string; authErrorUrl?: string }) {
      const authErrorUrl = preview.authErrorUrl || preview.currentUrl.replace('view=current', 'view=auth_error')
      this.visible = true
      this.preview = [
        {
          title: '応募ページ(キャンペーン開始前)',
          url: preview.beginUrl,
          value: 'begin'
        },
        {
          title: '応募ページ(キャンペーン期間中)',
          url: preview.currentUrl,
          value: 'current'
        },
        {
          title: '応募ページ(キャンペーン終了後)',
          url: preview.endUrl,
          value: 'end'
        },
        {
          title: '応募ページ(認証エラー)',
          url: authErrorUrl,
          value: 'auth_error'
        }
      ]
    },

    /**
     * ダイアログキャンペーンを閉じる
     */
    close() {
      this.visible = false
      this.preview = []
    },

    clickTrackingEvent(value: string) {
      switch (value) {
        case 'begin':
          TrackingService.sendEvent('click: WEB応募ページのプレビュー|応募ページ(キャンペーン開始前)')
          break
        case 'current':
          TrackingService.sendEvent('click: WEB応募ページのプレビュー|応募ページ(キャンペーン期間中)')
          break
        case 'end':
          TrackingService.sendEvent('click: WEB応募ページのプレビュー|応募ページ(キャンペーン終了後)')
          break
        case 'auth_error':
          TrackingService.sendEvent('click: WEB応募ページのプレビュー|応募ページ(認証エラー)')
          break
        default:
          break
      }
    }
  }
})
</script>
